var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactBooking50X50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50ZM18.7515 22.6406V27.3554H10.5472L10.5472 22.6406H18.7515ZM8.6604 27.3554V29.2422V34.1132C8.6604 35.1553 9.50514 36 10.5472 36H18.7515H20.6383H28.7896H30.6763H38.7736C39.8157 36 40.6604 35.1553 40.6604 34.1132V15.8868C40.6604 14.8447 39.8157 14 38.7736 14H30.6763H28.7896H20.6383H18.7515H10.5472C9.50515 14 8.6604 14.8447 8.6604 15.8868V27.3554ZM10.5472 34.1132H18.7515V29.2422H10.5472L10.5472 34.1132ZM28.7896 34.1132H20.6383V29.2422H28.7896V34.1132ZM38.7736 34.1132H30.6763V29.2422H38.7736V34.1132ZM38.7736 22.6406V27.3554H30.6763V22.6406H38.7736ZM38.7736 15.8868L38.7736 20.7538H30.6763V15.8868H38.7736ZM20.6383 15.8868H28.7896V20.7538H20.6383V15.8868ZM20.6383 22.6406V27.3554H28.7896V22.6406H20.6383Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBooking50X50);
export default __webpack_public_path__ + "static/media/contact-booking-50x50.54a42b77.svg";
export { ForwardRef as ReactComponent };